import { createAction } from "@reduxjs/toolkit"

import { ActionTypes } from "../actionTypes"

export const changeLanguage = (newLang: string) => (createAction(ActionTypes.language.change.typeName, () => ({ payload: newLang })))()
